/* eslint-disable class-methods-use-this */

// Storage abstraction for service provider unit selection
// This makes it easy to swap localStorage for another storage mechanism later

const FAVORITE_STORAGE_KEY = 'favorite-service-provider-unit-id';

export interface IServiceProviderUnitStorage {
  getFavoriteUnitId(): string | undefined;
  setFavoriteUnitId(unitId: string): void;
  clearFavoriteUnitId(): void;
}

class LocalStorageServiceProviderUnitStorage implements IServiceProviderUnitStorage {
  getFavoriteUnitId(): string | undefined {
    const value = localStorage.getItem(FAVORITE_STORAGE_KEY);
    return value ?? undefined;
  }

  setFavoriteUnitId(unitId: string): void {
    localStorage.setItem(FAVORITE_STORAGE_KEY, unitId);
  }

  clearFavoriteUnitId(): void {
    localStorage.removeItem(FAVORITE_STORAGE_KEY);
  }
}

// Export a singleton instance
// To swap storage mechanism, just change this implementation
export const serviceProviderUnitStorage: IServiceProviderUnitStorage = new LocalStorageServiceProviderUnitStorage();
